import types from "./servicesTypes";

export default {
  paid: event => ({
    type: types.SERVICE_PAID,
    event
  })
};
